// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetIndexAdvisorServerOverviewQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  checkGroupsAndNames?: Types.InputMaybe<
    Array<Types.Scalars["String"]["input"]> | Types.Scalars["String"]["input"]
  >;
}>;

export type GetIndexAdvisorServerOverviewQuery = {
  __typename?: "GraphqlQuery";
  getDatabases: Array<{
    __typename?: "Database";
    id: string;
    datname?: string | null;
    issueCount: number;
    tableCount: number;
    totalIndexSize: number;
    indexWriteOverhead: {
      __typename?: "DatabaseIndexWriteOverhead";
      totalWriteOverhead?: number | null;
    };
  }>;
};

export const GetIndexAdvisorServerOverviewDocument = gql`
  query GetIndexAdvisorServerOverview(
    $serverId: ID!
    $checkGroupsAndNames: [String!]
  ) {
    getDatabases(serverId: $serverId, hidden: false) {
      id
      datname
      issueCount(checkGroupsAndNames: $checkGroupsAndNames)
      tableCount
      totalIndexSize
      indexWriteOverhead {
        totalWriteOverhead
      }
    }
  }
`;

/**
 * __useGetIndexAdvisorServerOverviewQuery__
 *
 * To run a query within a React component, call `useGetIndexAdvisorServerOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndexAdvisorServerOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndexAdvisorServerOverviewQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      checkGroupsAndNames: // value for 'checkGroupsAndNames'
 *   },
 * });
 */
export function useGetIndexAdvisorServerOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIndexAdvisorServerOverviewQuery,
    GetIndexAdvisorServerOverviewQueryVariables
  > &
    (
      | {
          variables: GetIndexAdvisorServerOverviewQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIndexAdvisorServerOverviewQuery,
    GetIndexAdvisorServerOverviewQueryVariables
  >(GetIndexAdvisorServerOverviewDocument, options);
}
export function useGetIndexAdvisorServerOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndexAdvisorServerOverviewQuery,
    GetIndexAdvisorServerOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIndexAdvisorServerOverviewQuery,
    GetIndexAdvisorServerOverviewQueryVariables
  >(GetIndexAdvisorServerOverviewDocument, options);
}
// @ts-ignore
export function useGetIndexAdvisorServerOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIndexAdvisorServerOverviewQuery,
    GetIndexAdvisorServerOverviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetIndexAdvisorServerOverviewQuery,
  GetIndexAdvisorServerOverviewQueryVariables
>;
export function useGetIndexAdvisorServerOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIndexAdvisorServerOverviewQuery,
        GetIndexAdvisorServerOverviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetIndexAdvisorServerOverviewQuery | undefined,
  GetIndexAdvisorServerOverviewQueryVariables
>;
export function useGetIndexAdvisorServerOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIndexAdvisorServerOverviewQuery,
        GetIndexAdvisorServerOverviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIndexAdvisorServerOverviewQuery,
    GetIndexAdvisorServerOverviewQueryVariables
  >(GetIndexAdvisorServerOverviewDocument, options);
}
export type GetIndexAdvisorServerOverviewQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorServerOverviewQuery
>;
export type GetIndexAdvisorServerOverviewLazyQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorServerOverviewLazyQuery
>;
export type GetIndexAdvisorServerOverviewSuspenseQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorServerOverviewSuspenseQuery
>;
export type GetIndexAdvisorServerOverviewQueryResult = Apollo.QueryResult<
  GetIndexAdvisorServerOverviewQuery,
  GetIndexAdvisorServerOverviewQueryVariables
>;
